import all from './all';
import items from './items';
import store from './store';
import show from './show';
import update from './update';
import nextBatchNumber from './nextBatchNumber';
import setProcedureStatus from './setProcedureStatus';
import startBatch from './startBatch';
import completeBatch from './completeBatch';
import deductAllIngredience from './deductAllIngredience';
import updateBatchTransfer from './updateBatchTransfer';

export default {
  all,
  items,
  store,
  show,
  update,
  nextBatchNumber,
  setProcedureStatus,
  startBatch,
  completeBatch,
  deductAllIngredience,
  updateBatchTransfer,
};



// WEBPACK FOOTER //
// ./src/app/services/batch/index.js